import { ChangeDetectorRef, Component, ElementRef, OnInit, OnDestroy, ViewChild, NgZone } from '@angular/core';
import { HttpClient, HttpHeaders }  from '@angular/common/http';
import { ActivatedRoute, Router }            from '@angular/router';
import { API_BASE_URL }       from '../../environments/environment';
import { MatDialog, MatPaginator, MatTableDataSource } from '@angular/material';
import * as XLSX from 'xlsx';
import { BaseComponent } from '../base.component';
import { ContractDetailNoteDialogComponent } from './contract-detail-note-dialog/contract-detail-note-dialog.component';
import { InconsistencyDialogComponent } from './inconsistency-dialog/inconsistency-dialog.component';
import { MobileZoomService } from '../common/mobile-zoom/mobile-zoom.service';

@Component({
  selector: 'app-contract-detail',
  templateUrl: './contract-detail.component.html',
  styleUrls: ['./contract-detail.component.less']
})

export class ContractDetailComponent extends BaseComponent implements OnInit, OnDestroy {
  public headers = new HttpHeaders({
    "X-LoginAccessKey": localStorage.getItem("accessKey")
  });
  
  // テーブルのカラム名
  columnDefs = [
    'nameSite',
    'cdContract',
    'nameContentsWork',
    'mon',
    'tue',
    'wed',
    'thu',
    'fri',
    'sat',
    'sun',
    'monthlyFee',
    'monthlyHours',
    'hourlyWage',
    'note',
    'cleanPlus',
    'rank',
    'cdSite',
    'nameCustomer',
    'nameBranch',
    'startDateContract',
    'endDateContract',
    'holiday',
    'companyHoliday'
  ];

  // ページネーター
  @ViewChild(MatPaginator) paginator: MatPaginator;

  // エクスポート時の内容
  @ViewChild('TABLE') table: ElementRef;

  // テーブルのデータソース
  contractList = new MatTableDataSource();

  // エクスポート用データ
  exportData = [];

  // 絞込み_物件名
  filterNameSite = '';

  // 絞込み_得意先名
  filterNameCustomer = '';

  // 絞り込み_物件コード
  filterCdSite = '';

  // 絞り込み_契約コード
  filterCdContract = '';

  // 絞込み_ランク
  rank = '';
  // 絞込み_ランクリスト
  rankList = [
    { key: 'A', value: 'A' },
    { key: 'B', value: 'B' },
    { key: 'C', value: 'C' },
    { key: 'D', value: 'D' },
  ]

  // ローディング中の表示
  nowLoading = true;

  // エクスポート用ローディング
  loadingExport = false;

  // データ件数
  paginatorLength = 0;
  
  constructor(
    private route: ActivatedRoute,
    private http: HttpClient,
    private router: Router,
    private dialog: MatDialog,
    private dialog2: MatDialog,
    private cdr: ChangeDetectorRef,
    private ngZone: NgZone,
    public mz: MobileZoomService
    ) {
    super();
  }

  /**
   * ほかの画面へ移るときは viewport を元に戻す
   */
  ngOnDestroy() {
    this.mz.leave();
  }

  ngOnInit() {
    // スマホ：PC と同じ見た目を縮めて出す（MobileZoomService）。清掃員一覧と同じ一覧なので、iPhone 用に描画のやり直しもする
    this.mz.enter({ repaint: true });

    const cdSite = this.route.snapshot.paramMap.get('cdSite');
    const cdContract = this.route.snapshot.paramMap.get('cdContract');
    if (cdSite) {
      this.filterCdSite = cdSite
    }
    if (cdContract) {
      this.filterCdContract = cdContract
    }
  }

  goTo(comp, param){
    this.ngZone.run(()=>{
    this.router.navigate([comp, param])
    });
  }
  
  ngAfterViewInit() {
    // URL で物件コード・契約コードを指定して開いたときは、前回の物件名・得意先名と重ならないように空で始める
    if (!this.filterCdSite && !this.filterCdContract) {
      this.filterNameCustomer =
        localStorage.getItem('search_buildings_nameBillingAddress') != null ? localStorage.getItem('search_buildings_nameBillingAddress') : "";
      this.filterNameSite =
        localStorage.getItem('search_buildings_nameSite') != null ? localStorage.getItem('search_buildings_nameSite') : "";
    }
    // this.rank = 
    //   localStorage.getItem('search_rank') ? localStorage.getItem('search_rank') : "";
      this.contractList.paginator = this.paginator;
    this.paginator.page.subscribe(() => {
      this.getContractDetailList(this.paginator.pageIndex, this.paginator.pageSize);
    })
    
    this.dialog.afterAllClosed.subscribe(res => {
      this.getContractDetailList(this.paginator.pageIndex, this.paginator.pageSize);
    });
    this.cdr.detectChanges();
  }

  /**
   * リストのデータ取得
   */
  getContractDetailList(index: number, size: number) {
    this.nowLoading = true;
    this.paginatorLength = 0;

    localStorage.setItem('search_buildings_nameBillingAddress', this.filterNameCustomer);
    localStorage.setItem('search_buildings_nameSite', this.filterNameSite);
    localStorage.setItem('search_rank', this.rank);

    this.http.get(
      API_BASE_URL + '/api/v1/contractDetail?s=0&e=8000&index='
        + index
        + '&size=' + size
        + '&filterNameSite=' + encodeURIComponent(this.filterNameSite)
        + '&filterNameCustomer=' + encodeURIComponent(this.filterNameCustomer)
        + '&filterCdSite=' + encodeURIComponent(this.filterCdSite)
        + '&filterCdContract=' + encodeURIComponent(this.filterCdContract)
        + '&rank=' + (this.rank || ''),
      {headers: this.headers}
    )
    .subscribe(res => {
      let data = res as any[];
      if (data.length && data.length > 0) {
        this.contractList = new MatTableDataSource(data);
        this.paginatorLength = data[0].totalSize;
      } else {
        this.contractList = new MatTableDataSource([]);
        this.paginatorLength = 0;
      }
      this.nowLoading = false;
    },
    error => {
      alert("認証に失敗しました");
      this.router.navigate(['/']);
      this.nowLoading = false;
    });
  }

  /**
   * エクスポート用に全件取得
   */
  getAll() {
    this.loadingExport = true;

    this.http.get(
      API_BASE_URL + '/api/v1/contractDetail/allContractDetail?s=0&e=8000'
        + '&filterNameSite=' + encodeURIComponent(this.filterNameSite)
        + '&filterNameCustomer=' + encodeURIComponent(this.filterNameCustomer)
        + '&filterCdSite=' + encodeURIComponent(this.filterCdSite)
        + '&filterCdContract=' + encodeURIComponent(this.filterCdContract)
        + '&rank=' + (this.rank || ''),
      {headers: this.headers}
    )
    .subscribe(res => {
      let allData = res as [];
      if (allData && allData.length) {
        this.exportData = [];
        // エクセル用にカラムを生成
        for (let i = 0; i < allData.length; i++) {
          const a = allData[i];

          // 契約開始日
          let startDateContract = '';
          if (a['startDateContract'] != 0) {
            startDateContract = a['startDateContract'];
          }

          // 契約終了日
          let endDateContract = '';
          if (a['endDateContract'] != 0) {
            endDateContract = a['endDateContract'];
          }

          this.exportData.push({
              '物件名': a['nameSite']
            , '契約コード': a['cdContract']
            , '作業内容': a['nameContentsWork']
            , '月曜': a['mon']
            , '月曜出勤形態': this.attendance(a['attendanceMonday'])
            , '火曜': a['tue']
            , '火曜出勤形態': this.attendance(a['attendanceTuesday'])
            , '水曜': a['wed']
            , '水曜出勤形態': this.attendance(a['attendanceWednesday'])
            , '木曜': a['thu']
            , '木曜出勤形態': this.attendance(a['attendanceThursday'])
            , '金曜': a['fri']
            , '金曜出勤形態': this.attendance(a['attendanceFriday'])
            , '土曜': a['sat']
            , '土曜出勤形態': this.attendance(a['attendanceSaturday'])
            , '日曜': a['sun']
            , '日曜出勤形態': this.attendance(a['attendanceSunday'])
            , '月額': this.amountFormat(a['monthlyFee'])
            , '月時間': a['monthlyHours']
            , '時給単価': this.amountFormat(a['hourlyWage'])
            , '祝日出勤': a['nameKubunHolidayContract']
            , '全社休日出勤': a['hasExportingCompanysHolidayContractName']
            , '備考': a['note']
            , 'クリーンプラス': this.amountFormat(a['cleanPlus'])
            , '物件ランク': a['rank']
            , '物件コード': a['cdSite']
            , '得意先名': a['nameCustomer']
            , '支店名': a['nameBranch']
            , '契約開始日': startDateContract
            , '契約終了日': endDateContract
          })
        }
      } else {
        this.exportData = [];
      }
      this.exportXlsx();
      this.loadingExport = false;
    },
    error => {
      alert("認証に失敗しました");
      this.router.navigate(['/']);
    });
  }

  /**
   * 検索実行
   */
  applyFilter() {
    this.paginator.pageIndex = 0;
    this.getContractDetailList(this.paginator.pageIndex, this.paginator.pageSize)
  }

  /**
   * 出勤形態の表示（バックが get_attendance_name で名前にして返す。毎週は空）
   * @param val 出勤形態の名前（第2週・隔週など）
   * @returns
   */
  attendance(val) {
    if (!val) {
      return '';
    }
    return '（' + val + '）';
  }

  /**
   * エクスポート
   */
  exportXlsx() {
    const ws: XLSX.WorkSheet=XLSX.utils.json_to_sheet(this.exportData);
    const wb: XLSX.WorkBook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');

    /* save to file */
    XLSX.writeFile(wb, '契約詳細.xlsx');
  }

  /**
   * 背景色設定
   * @param index 番号
   */
  setBgColor(index: number) {
    if (index % 2 == 0) {
      return 'blue-contract-bg';
    }
  }

  /**
   * 備考欄編集イベント
   * @param row 対象データ
   */
  editNote(row) {
    this.dialog.open(ContractDetailNoteDialogComponent, {
      data: { ...row, type: 'note' }
    });
  }

  /**
   * ラウンドクリーン欄編集イベント
   * @param row 対象データ
   */
  editCleanPlus(row) {
    this.dialog.open(ContractDetailNoteDialogComponent, {
      data: { ...row, type: 'cleanPlus' }
    });
  }

  /**
   * ランク欄編集イベント
   * @param row 対象データ
   */
  editRank(row) {
    this.dialog.open(ContractDetailNoteDialogComponent, {
      data: { ...row, type: 'rank' }
    });
  }

  /**
   * 不整合一覧
   */
  openInconsistencyDialog() {
    this.dialog2.open(InconsistencyDialogComponent, {});
  }

  /**
   * 金額を3桁区切りにする
   * @param val 値
   * @returns 
   */
  amountFormat(val) {
    if (!val) {
      return null
    } else {
      return Number(val).toLocaleString()
    }
  }
}
